import apiClient from "./BaseService";
import { URL } from "../config";

const _editProfileData = async (id: any, data:any) => {
    return apiClient.patch(`${URL.UPDATE_PROFILE_DATA}${id}/`, data)
}
const _getProfileData = async (userId :any) =>
    apiClient.get(`${URL.GET_PROFILE_DATA}${userId}/`);


export const PofileService = {
    _getProfileData,
    _editProfileData
}